import { loadLocalWebPushUserSetting, getUserPreferenceIdentifier, getLocalWebPushUserSettingStore, } from 'owa-webpush-notifications';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getWebPushNotificationsOption } from './getWebPushNotificationsOption';
export function getLocalWebPushUserSetting() {
    var mbxGuid = getUserConfiguration().SessionSettings.MailboxGuid;
    var userPreferenceIdentifier = getUserPreferenceIdentifier(mbxGuid, getWebPushNotificationsOption());
    loadLocalWebPushUserSetting(window, userPreferenceIdentifier);
    return getLocalWebPushUserSettingStore();
}
//# sourceMappingURL=getLocalWebPushUserSetting.js.map